import { ReactComponent as SmallLogoBack } from 'core/assets/images/general/logoLauriaBackMini.svg'
import { ReactComponent as SmallLogo } from 'core/assets/images/general/logoLauriaMini.svg'
import { ROUTE_PATHS } from 'core/constants/routePath'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router'

export const SmallLogoLink: React.FC<{ backoffice?: boolean }> = ({
  backoffice = false,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const homePath = generatePath(
    backoffice ? ROUTE_PATHS.DASHBOARD : ROUTE_PATHS.IASTART
  )

  const handleGoHome = () => {
    navigate(homePath, { replace: true })
  }

  return (
    <button
      type="button"
      onClick={handleGoHome}
      className="flex flex-row w-auto items-center text-gray-1325 ml-[30px]"
    >
      {backoffice ? (
        <SmallLogoBack className="h-[45px] w-[45px]" />
      ) : (
        <SmallLogo className="h-[45px] w-[45px]" />
      )}

      <div className="flex flex-col ml-10px text-left">
        <div className="text-[13px] font-medium">
          {t('applications.homeTitle')}
        </div>

        <div className="text-[11px] underline">{t('applications.goHome')}</div>
      </div>
    </button>
  )
}
